var $name="toggleElementDisplay",$path="app/utilities/toggleElementDisplay.js",$this={$name,$path,};function toggleElementDisplay(element, condition, whenTrue = 'block', whenFalse = 'none') {
  element.style.display = condition ? whenTrue : whenFalse;
}

export default toggleElementDisplay;
